module.exports = {"prices":{"error":"No prices found for EMA"}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/parking/EMA.json
// module id = 133
// module chunks = 119